import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "panel"]

  connect() {
    this.close()
    this.handleFocusIn = this.handleFocusIn.bind(this)
    window.addEventListener("focusin", this.handleFocusIn)
  }

  disconnect() {
    window.removeEventListener("focusin", this.handleFocusIn)
  }

  toggle() {
    this.expanded ? this.close() : this.open()
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
      this.toggleTarget.focus()
    }
  }

  handleFocusIn(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  open() {
    this.panelTarget.style.visibility = "visible"
    this.panelTarget.style.height = `${this.panelTarget.scrollHeight}px`
    this.toggleTarget.setAttribute("aria-expanded", "true")
  }

  close() {
    this.panelTarget.style.height = "0"
    this.panelTarget.style.visibility = "hidden"
    this.toggleTarget.setAttribute("aria-expanded", "false")
  }

  get expanded() {
    return this.toggleTarget.getAttribute("aria-expanded") === "true"
  }
}
